(function(){
    'use strict';

    angular
        .module('app.contact')
        .controller('ContactController', ContactController);

    function ContactController($timeout, API, $state, $filter) {
        let vm = this;

    		vm.enderecos = [];

        vm.submitContact = (Contact) => {
    			API.post(`contact`, Contact)
    		   .then(result => swal('Enviado com sucesso!', '', 'success'))
    		   .then(() => {
    			   angular.copy({}, Contact)
    			   vm.ItsOkayForm.$submitted = false;
    			   vm.ItsOkayForm.$setPristine();
    		   })
    		   .catch(error => {
      			 console.log(error, 'error');
      			 swal({title: 'Opss...!', text: 'Tente novamente!', type: 'error'}).then(() => $state.reload());
    		   });
        }

        vm.$onInit = () => {
    		  _loadFromApi();
          _loadRedesSociais();
    		}

        function _loadRedesSociais() {
  				API.get(`configuracao/sociais`)
  				.then(result => vm.redesSociais = result.data[0])
  				.catch(error => {
  				  console.log(error, 'error');
  				});
  			}

    		function _loadFromApi() {
    		  _loadEnderecos()
            .then(address => _showMap(address));
    		}

        function _showMap(addresses){
          console.log(addresses)
    			$timeout(() => {
            let map = new google.maps.Map(document.getElementById('contact-map__map'), {
              zoom: 5,
              scrollwheel: false,
              center: {lat: -19.0083148, lng: -52.3200661}
            });

            addresses.forEach(address => {

              var contentString =
                '<div id="content">' +
                '   <div class="info-map">' +
                '       <h2 class="info-map__title">' + address.cidade_endereco + ' - ' + address.estado_endereco + '</h2>' +
                '       <div class="info-map__link"><a href="tel:' + address.telefone_endereco + '" target="_blank"> ' + $filter('phone')(address.telefone_endereco) + ' </a></div>' +
                '       <div class="info-map__description">' + address.titulo_endereco + '</div>' +
                '   </div>' +
                '</div>';

              var infowindow = new google.maps.InfoWindow({
                  content: contentString
              });

              let center = {
                lat: Number(address.latitude_endereco),
                lng: Number(address.longitude_endereco)
              };

              let marker = new google.maps.Marker({
                content: contentString,
                position: center,
                map,
                icon: 'media/mark-map.png'
              });

              marker.addListener('click', function () {
                  infowindow.open(map, marker);
              });
            });
    			}, 500);
    		}


    		function _loadEnderecos() {
    		  return API.get(`endereco`)
    				.then(result => result.data)
    				.then(enderecos => vm.enderecos = enderecos)
    				.catch(error => {
    				  console.log(error, 'error');
    				});
    		}
    }

})();
